"use strict";

exports.__esModule = true;
exports.sortStaff = void 0;
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
const sortStaff = ({
  service,
  serviceOptionsAndVariants
}) => {
  const resourceVariants = (0, _bookingsCalendarCatalogViewerMapper.getStaffVariantsFromAllVariants)(service, serviceOptionsAndVariants);
  return (a, b) => {
    var _resourceVariants$var, _resourceVariants$var2, _a$name, _b$name;
    const staffAPrice = resourceVariants == null || (_resourceVariants$var = resourceVariants.variants[a.staffMemberId]) == null ? void 0 : _resourceVariants$var.value;
    const staffBPrice = resourceVariants == null || (_resourceVariants$var2 = resourceVariants.variants[b.staffMemberId]) == null ? void 0 : _resourceVariants$var2.value;
    const staffAName = (_a$name = a.name) == null ? void 0 : _a$name.toLocaleLowerCase();
    const staffBName = (_b$name = b.name) == null ? void 0 : _b$name.toLocaleLowerCase();
    if (staffAPrice && staffBPrice) {
      return Number(staffAPrice) - Number(staffBPrice) || staffAName.localeCompare(staffBName);
    }
    return staffAName.localeCompare(staffBName);
  };
};
exports.sortStaff = sortStaff;
//# sourceMappingURL=sortStaff.js.map